import { render, staticRenderFns } from "./ClientViewGlobal.vue?vue&type=template&id=3fe80fbc"
import script from "./ClientViewGlobal.vue?vue&type=script&lang=js"
export * from "./ClientViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports